module.exports = __webpack_public_path__ + "img/celtiis.0d4d6ab3.webp";